module.exports = __webpack_public_path__ + "img/nature-60.bc4f6c26.jpg";